import React from 'react';
import ListGroup from 'reactstrap/lib/ListGroup';
import ListGroupItem from 'reactstrap/lib/ListGroupItem';
import Table from 'reactstrap/lib/Table';
import Button from 'reactstrap/lib/Button';

interface TabsCategoryItemProps {
	children: React.ReactNode;
	key?: string;
	onClick?: () => void;
	active?: boolean;
}

interface TabsListEmptyProps {
	message: string;
}

interface TabsListItemNameProps {
	onClick: () => void;
	children: React.ReactNode;
}

interface TabsListActionsItemProps {
	onClick: () => void;
	children: React.ReactNode;
}

interface TabsComponentChildrenOnlyProps {
	children: React.ReactNode;
}

interface TabsListRowProps {
	key: number | string;
	children: React.ReactNode;
}

/**
 * Component for displaying tabs with left and right column
 *
 */
function Tabs(props: TabsComponentChildrenOnlyProps) {
	return <div className="tabs">{props.children}</div>;
}

export default Tabs;

/**
 * Component for displaying tab category column
 *
 */
export function TabsCategory(props: TabsComponentChildrenOnlyProps) {
	return (
		<div className="tabs__categories">
			<ListGroup className="tabs__cat-list">{props.children}</ListGroup>
		</div>
	);
}

/**
 * Component for displaying tab category item.
 *
 */
export function TabsCategoryItem(props: TabsCategoryItemProps) {
	const { onClick, key, active, children } = props;

	return (
		<>
			<ListGroupItem
				key={key}
				active={active}
				onClick={onClick}
				tag="button"
				type="button"
				focusable="false"
				tabIndex={-1}
				className="tabs__category-item"
			>
				{children}
			</ListGroupItem>
		</>
	);
}

/**
 * Component for displaying tabs list.
 *
 */
export function TabsList(props: TabsComponentChildrenOnlyProps) {
	return (
		<div className="tabs__list">
			<div className="tabs__table-wrapper">
				<Table striped responsive className="tabs-table">
					<tbody>{props.children}</tbody>
				</Table>
			</div>
		</div>
	);
}

/**
 * Component for displaying a tabs list actions.
 *
 */
export function TabsListActions(props: TabsComponentChildrenOnlyProps) {
	return <div className="tabs-table__actions">{props.children}</div>;
}

/**
 * Component for displaying a tabs list action item.
 *
 */
export function TabsListActionsItem(props: TabsListActionsItemProps) {
	return (
		<Button className="tabs-table__actions-item" color="link" type="button" onClick={props.onClick}>
			{props.children}
		</Button>
	);
}

/**
 * Component for displaying empty tab list.
 *
 */
export function TabsListEmpty(props: TabsListEmptyProps) {
	return (
		<div className="tabs__empty">
			<em>{props.message}</em>
		</div>
	);
}

/**
 * Component for displaying a tabs list item.
 *
 */
export function TabsListItem(props: TabsComponentChildrenOnlyProps) {
	return <td className="tabs-table__td">{props.children}</td>;
}

/**
 * Component for displaying a tabs list item.
 *
 */
export function TabsListItemName(props: TabsListItemNameProps) {
	return (
		<button onClick={props.onClick} className="tabs-table__name-btn" type="button">
			{props.children}
		</button>
	);
}

/**
 * Component for displaying a tabs list row.
 *
 */
export function TabsListRow(props: TabsListRowProps) {
	return <tr key={props.key}>{props.children}</tr>;
}
